import * as React from 'react';
import { Outlet } from 'react-router-dom';

const Qr: React.FC = () => {
  return <Outlet />;
};

export default Qr;
